var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLancherixDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10000.000000pt",
    height: "10000.000000pt",
    viewBox: "0 0 10000.000000 10000.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,10000.000000) scale(0.100000,-0.100000)",
    fill: "rgba(255, 255, 255, 0.8)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 99550 l0 -450 400 0 400 0 0 450 0 450 -400 0 -400 0 0 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99200 99550 l0 -450 400 0 400 0 0 450 0 450 -400 0 -400 0 0 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63720 79849 c-1744 -58 -3375 -232 -5015 -533 -6257 -1149 -11967 -4083 -16550 -8502 -1254 -1209 -2452 -2567 -3490 -3954 -392 -525 -448 -597 -1354 -1770 -2852 -3691 -4692 -6056 -5430 -6980 -306 -383 -423 -511 -936 -1025 -2283 -2287 -4443 -3797 -6710 -4690 -2274 -897 -4666 -1145 -7205 -749 -4082 636 -6834 2031 -10715 5430 -1633 1430 -3307 3051 -6192 5994 l-123 125 0 -18922 0 -18923 50000 0 50001 0 -4 10633 c-3 7835 -7 10704 -15 10907 -6 151 -19 421 -27 600 -319 6645 -2576 12944 -6547 18268 -793 1064 -1618 2044 -2572 3057 -406 430 -1208 1220 -1686 1659 -2855 2625 -6158 4774 -9757 6347 -3818 1669 -7951 2674 -12168 2959 -288 19 -675 40 -1125 61 -298 14 -2041 20 -2380 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 450 l0 -450 400 0 400 0 0 450 0 450 -400 0 -400 0 0 -450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99200 450 l0 -450 400 0 400 0 0 450 0 450 -400 0 -400 0 0 -450z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLancherixDark);
export default __webpack_public_path__ + "static/media/lancherixDark.9785e6627d52f399fc38733701f9c531.svg";
export { ForwardRef as ReactComponent };